import { render, staticRenderFns } from "./ExchangeGroup.vue?vue&type=template&id=3fcf500e&"
import script from "./ExchangeGroup.vue?vue&type=script&lang=ts&"
export * from "./ExchangeGroup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports